function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, contacts) {
  var keylist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var html = "<div id=\"saito-contacts-modal\" class=\"saito-contacts\">\n                <h2 class=\"saito-modal-title\">".concat(contacts.title, "</h2>\n                <div class=\"saito-modal-content saito-menu-select-heavy\">\n              ");
  var userTemplate = function userTemplate(public_key, shared) {
    var imgsrc = app.keychain.returnIdenticon(public_key);
    var name = app.keychain.returnIdentifierByPublicKey(public_key, true);
    if (name == public_key) {
      name = 'Anonymous User';
    }
    var html = "<div class=\"saito-contact\" data-id=\"".concat(public_key, "\">");
    if (contacts.multi_select) {
      html += "<input type=\"checkbox\" class=\"saito-checkbox\" data-id=\"".concat(public_key, "\"/>");
    }
    html += "<div class=\"saito-user\">";
    if (shared) {
      html += "<i class=\"fa-solid fa-lock secure-contact-notice\"></i>";
    }
    html += "<div class=\"saito-identicon-box\"><img class=\"saito-identicon\" src=\"".concat(imgsrc, "\"></div>\n\t                  ").concat(name, "\n\t                <div class=\"saito-userline\">").concat(public_key, "</div>\n\t              </div>\n\t            </div>");
    return html;
  };
  if (keylist) {
    var _iterator = _createForOfIteratorHelper(keylist),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var publicKey = _step.value;
        var key = app.keychain.returnKey(publicKey, true);
        html += userTemplate(publicKey, key === null || key === void 0 ? void 0 : key.aes_publicKey);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    var keys = app.keychain.returnKeys();
    for (var i = 0; i < keys.length; i++) {
      var _keys$i;
      //filter out group keys
      if (!((_keys$i = keys[i]) !== null && _keys$i !== void 0 && _keys$i.group)) {
        var _keys$i2;
        var _publicKey = keys[i].publicKey;
        html += userTemplate(_publicKey, (_keys$i2 = keys[i]) === null || _keys$i2 === void 0 ? void 0 : _keys$i2.aes_publicKey);
      }
    }
  }
  html += '</div>';
  if (contacts.multi_select) {
    html += "<button id=\"saito-contact-submit\" class=\"saito-button-primary\" type=\"button\">".concat(contacts.multi_button, "</button>");
  }
  html += '</div>';
  return html;
};